module.exports = ".body\r\n{\r\n    direction:rtl;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/discount/discount-edit-dialog/discount-edit-dialog.component.css
// module id = ./src/app/components/discount/discount-edit-dialog/discount-edit-dialog.component.css
// module chunks = main